import { render, staticRenderFns } from "./sbpoint.vue?vue&type=template&id=08eba1fc&scoped=true"
import script from "./sbpoint.vue?vue&type=script&lang=js"
export * from "./sbpoint.vue?vue&type=script&lang=js"
import style0 from "./sbpoint.vue?vue&type=style&index=0&id=08eba1fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eba1fc",
  null
  
)

export default component.exports